import React from 'react';
import type { Components } from '@atlassian/jira-polaris-lib-timeline/src/types.tsx';
import { RowGroup } from '../row-group/index.tsx';

export const RowGroupPreview: Components['RowGroupPreview'] = (props) => (
	<RowGroup {...props} isPreview />
);
